import * as React from 'react';
import * as toastr from 'toastr';

import Fieldset from '../components/forms/Fieldset';
import { TextInput } from '../components/forms';
import { Page, PageContent, PageHeader } from '../components/common';
import { Button } from '../components/buttons';
import Utils from '../common/utils';

interface Props {}
interface State {
	password: string;
	passwordVerification: string;
	touched: {
		password: boolean;
		passwordVerification: boolean;
	};
}
class ResetPasswordPage extends React.Component<Props, State> {
	errors = {} as any;

	constructor(props: Props) {
		super(props);
		this.state = {
			password: '',
			passwordVerification: '',
			touched: {
				password: false,
				passwordVerification: false
			}
		};
	}

	validate = () => {
		return {
			password: { hasError: this.state.password.length < 8, message: 'Minimum 8 characters required.' },
			passwordVerification: {
				hasError: this.state.passwordVerification !== this.state.password,
				message: 'Passwords do not match.'
			}
		};
	}

	onBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}

	onChange = (e: any) => {
		this.setState({ [e.target.name]: e.target.value });
	}

	submit = () => {
		toastr.info('Not yet implemented!');
	}

	isSubmitDisabled = () => {
		const errors = this.validate();
		return errors.password.hasError || errors.passwordVerification.hasError;
	}

	render() {
		this.errors = this.validate();
		return (
			<Page title="Reset Password">
				<PageContent>
					<PageHeader title="Reset your password" isCentered={true} />
					<Fieldset>
						<TextInput
							labelText="Password"
							type="password"
							name="password"
							onBlur={this.onBlur('password')}
							onChange={this.onChange}
							value={this.state.password}
							required={true}
							error={
								Utils.shouldMarkError(this.errors.password, this.state.touched.password)
									? this.errors.password
									: undefined
							}
						/>
						<TextInput
							labelText="Re-enter your password"
							type="password"
							name="passwordVerification"
							onBlur={this.onBlur('passwordVerification')}
							onChange={this.onChange}
							value={this.state.passwordVerification}
							required={true}
							className="mb-0"
							error={
								Utils.shouldMarkError(this.errors.passwordVerification, this.state.touched.passwordVerification)
									? this.errors.passwordVerification
									: undefined
							}
						/>
						<Button className="btn-primary" onClick={this.submit} disabled={this.isSubmitDisabled()}>
							Submit
						</Button>
					</Fieldset>
				</PageContent>
			</Page>
		);
	}
}

export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/ResetPasswordPage.tsx